import * as React from 'react';
import type { SVGProps } from 'react';
const SvgYourInitials = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M13 5c-.522 3.288-1.363 6.823-2.853 9.778-.75 1.488-2.062 3.927-3.815 4.192-1.044.158-1.794-.32-2.203-1.331-.363-.897.097-1.578.667-2.181M13 5c0 2.71-.007 6.92 1.412 9.293C15.039 15.343 16 17 17.5 17.5"
    />
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 18c1-1 2.316-1.562 4.065-2.6 1.175-.698 2.483-1.126 3.83-1.316a7.3 7.3 0 0 1 1.225-.082c.634.017 1.395.133 1.947.495.524.345.933.84.933 1.416 0 1.005-.634 2.059-2.5 1.587"
    />
  </svg>
);
export default SvgYourInitials;
